import { Form, Input, InputNumber, Select } from "antd";
import { ContainerModal, formStyle, TextModal } from "../styles";
import { layout } from "../../ViewGerenciarPropriedadeUsuario/constant/layout";
import { TitleModal } from "../../ViewGerenciarPropriedadeUsuario/styles";
import { Dispatch, SetStateAction, useRef } from "react";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import {
  formatBRLCurrency,
  parseBRLCurrency,
} from "../../../uteis/formatValorReal";

const situacaoPropriedade = [
  //Array de Opções usadas no SELECT de dias da semana
  { id: 1, label: "Escriturado", value: "ESCRITURADO" },
  { id: 2, label: "Quitado", value: "QUITADO" },
  { id: 3, label: "Não Quitado", value: "NAO_QUITADO" },
  { id: 4, label: "Na planta", value: "NA_PLANTA" },
];

interface FormAnunciioPropriedadeProps {
  dadosCotaUsuario: CotaUsuario;
  setDadosCotaUsuario: Dispatch<SetStateAction<CotaUsuario>>;
}

export default function FormAnuncioPropriedade({
  dadosCotaUsuario,
  setDadosCotaUsuario,
}: FormAnunciioPropriedadeProps) {
  const [formAnuncioPropriedade] = Form.useForm();

  const situacaoRef = useRef<string>();

  const maisInfoChange = (
    changedValues: Partial<CotaUsuario>,
    allValues: CotaUsuario
  ) => {
    const { situacao } = allValues;

    situacaoRef.current = situacao;

    // Atualize o estado com os valores modificados
    setDadosCotaUsuario((prevState: CotaUsuario) => ({
      ...prevState,
      ...changedValues,
    }));

    if (situacao !== "NAO_QUITADO") {
      formAnuncioPropriedade.setFieldsValue({ saldoDevedor: null });
    }
  };

  return (
    <>
      <ContainerModal>
        {" "}
        <TitleModal>Mais Info Anuncio Propriedade</TitleModal>
        <Form
          {...layout}
          form={formAnuncioPropriedade}
          name="formAnuncioPropriedade"
          onValuesChange={(changedValues, allValues) =>
            maisInfoChange(changedValues, allValues)
          }
          style={formStyle}
        >
          <TextModal>Mais Informações</TextModal>
          <Form.Item
            name={["situacao"]}
            label="Situação da propriedade"
            className="formItems"
            //style={{ width: "100%", marginBottom: "24px" }}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 10 }}
          >
            <Select placeholder="Situação da propriedade">
              {situacaoPropriedade.map((dias) => (
                <Select.Option key={dias.id} value={dias.value}>
                  {dias.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={["valorVenda"]}
            label="Valor da Venda"
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 11 }}
            wrapperCol={{ span: 24 }}
          >
            <InputNumber
              placeholder="Digite o valor da venda"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name={["valorCondominio"]}
            label="Valor do Condomínio"
            className="formItems"
            style={{ width: "60%", marginBottom: "24px" }}
            labelCol={{ span: 14 }}
            wrapperCol={{ span: 50 }}
          >
            <InputNumber
              placeholder="Digite o valor do condomínio"
              formatter={(value) => {
                if (value === undefined || value === null) return "";
                return `R$ ${Number(value).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`;
              }}
              parser={(value) => {
                if (!value) return "";
                const onlyNumbers = value.replace(/\D+/g, ""); // Remove tudo que não for número
                const parsedValue = (parseFloat(onlyNumbers) / 100).toFixed(2); // Converte para decimal
                return isNaN(Number(parsedValue)) ? "" : parsedValue;
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>

          {dadosCotaUsuario.situacao === "NAO_QUITADO" && (
            <Form.Item
              name={["saldoDevedor"]}
              label="Saldo devedor"
              className="formItems"
              style={{ width: "60%", marginBottom: "24px" }}
              labelCol={{ span: 11 }}
              wrapperCol={{ span: 24 }}
            >
              <InputNumber
                placeholder="Digite o Saldo devedor"
                formatter={formatBRLCurrency}
                parser={parseBRLCurrency}
                style={{ width: "100%" }}
              />
            </Form.Item>
          )}
          <Form.Item
            name={["descricao_anuncio"]}
            label="Descriçao "
            className="formItems"
            //style={{ width: "100%", marginBottom: "24px" }}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 10 }}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </ContainerModal>
    </>
  );
}
